import { Views, View } from 'react-big-calendar';

import Tasks from 'APP/Tasks';
import { storage } from 'APP/packages/storage';
import { getVisibleRange } from 'APP/utils/calendar/getVisibleRange';
import { normalizeAllDay } from 'APP/utils/calendar/normalizeAllDay';
import Entities from 'STORE';

export const initialize = async (): Promise<boolean> => {
  Entities.calendar.setLoading(true);

  let currentDate: Date | null = Entities.calendar.currentDate;

  if (!currentDate) {
    currentDate = new Date();
    Entities.calendar.setCurrentDate(currentDate);
  }

  const currentViewCalendar = storage.calendar.getCalendarCurrentView();
  const currentViewFinal =
    (currentViewCalendar as Exclude<View, 'work_week' | 'agenda'>) || Views.WEEK;

  const currentView = [Views.DAY, Views.WEEK, Views.MONTH].includes(currentViewFinal)
    ? currentViewFinal
    : Views.WEEK;
  Entities.calendar.setCurrentView(currentView);

  const { start, end } = getVisibleRange(currentView, currentDate);

  const events = await Tasks.calendar.getCalendarEvents({
    from: BigInt(start.valueOf()),
    to: BigInt(end.valueOf()),
  });

  if (!events) {
    Entities.calendar.setLoading(false);
    return false;
  }

  Entities.calendar.setEventsMap({
    [`${start.getTime()}-${end.getTime()}`]: events
      ? events.map((event) => {
          return event.allDay ? normalizeAllDay(event) : event;
        })
      : null,
  });

  Entities.calendar.setLoading(false);
  return true;
};
